import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild}       from '@angular/core';
import {
  ApDynComponentComponent
}                                                                     from '../../ap-dyncomponent/ap-dyncomponent.component';
import {BehaviorSubject, combineLatest, Observable, of, Subscription} from 'rxjs';
import {
  ApDynGridColumnConfigBase,
  ApDynGridColumnHideConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-column-config-base';
import {
  ApDynGridPagerWizardButton,
  ApDynGridPagerWizardConfig,
  ApDynGridPagerWizardSection
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-pager-wizard-config';
import {
  ApDynGridStatusColumnConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-status-column-config';
import {
  nameOf
}                                                                     from '../../ap-core/utils/ap-name-of';
import {
  ApDynGridPropertyColumnConfig,
  FilterType,
  PropertyTemplate
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-property-column-config';
import {
  GetRoundNumericService
}                                                                     from '../../ap-utils/service/get-round-numeric.service';
import {
  FieldStore
}                                                                     from '../../stores/farm/field.store';
import {filter, map, skip}                                            from 'rxjs/operators';
import {ApTimeSpanUtil, GetRoundNumericPipe}                          from '../../ap-utils';
import {ObjectFactory}                                                from 'ts-tooling';
import {
  SettingsStore
}                                                                     from '../../stores/base-data/settings.store';
import {
  IPpEntryPlanBookingGridItem,
  IPpPlanBookingComponentData
}                                                                     from './plan-booking/pp-plan-booking.types';
import {
  ApDynGridGroupColumnConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-group-column-config';
import {
  LanguageStore
}                                                                     from '../../stores/translation/language.store';
import {MapViewMode}                                                  from '../../ap-interface';
import {
  MapViewStore
}                                                                     from '../../stores/layout/mapview.store';
import {
  ApUtilService
}                                                                     from '../../ap-utils/service/ap-util.service';
import {
  FormStore
}                                                                     from '../../stores/layout/form.store';
import {
  ApDynformsConfigFieldset
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigDatepicker
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-datepicker';
import {
  ApDynformsConfigTimepicker
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-timepicker';
import {
  ApDynformsConfigComboBox
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-combobox';
import {
  ApDynformsConfigPlaceholder
}                                                                     from '../../ap-dynforms/config/ap-dynforms-config-placeholder';
import {
  MachineStore
}                                                                     from '../../stores/docu/machine.store';
import {
  InstrumentStore
}                                                                     from '../../stores/docu/instrument.store';
import {
  DriverStore
}                                                                     from '../../stores/docu/driver.store';
import {
  CampaignYearStore
}                                                                     from '../../stores/login/campaignyear.store';
import {
  LoginStore
}                                                                     from '../../stores/login/login.store';
import {
  IModalDialogData,
  ModalDialogButtonDisable
}                                                                     from '../../ap-interface/interfaces/ap-modaldialog-data.interface';
import {
  ModalDialogStore
}                                                                     from '../../stores/dialog/modal.dialog.store';
import {
  ApTranslationService
}                                                                     from '../../ap-utils/service/ap-translation.service';
import {
  ApDateService
}                                                                     from '../../ap-core/services/ap-date-service';
import {
  CropTypeStore
}                                                                     from '../../stores/base-data/crop.types.store';
import {
  ApDynGridEditColumnConfig
}                                                                     from '../../ap-dyngrids/config/ap-dyn-grid-edit-column-config';
import {
  PlantProtectionPlanBookStore
}                                                                     from '../../stores/plant-protection/plant-protection-planbook.store';
import {
  PpNoDataValue
}                                                                     from '../../plant-protection/types/pp-planning-booking.types';
import {
  PpCommonService
}                                                                     from '../../plant-protection/services/pp-common.service';
import {
  ApNutrientService
}                                                                     from '../../ap-utils/service/ap-nutrient.service';
import IPlantProtectionPlanBook = Data.TaskManagement.IPlantProtectionPlanBook;

@Component({
  selector: 'pp-plan-booking',
  template: `
    <ap-dyncomponent [caption]="componentCaption"
                     [headerIcon]="'ap-fungidetect-icon'"
                     [loading$]="loading$"
                     [columns]="columns$ | async"
                     [items]="items$ | async"
                     [pager]="pager"
                     (edit)="onEdit($event)">
    </ap-dyncomponent>
  `,
  styles: []
})
export class PpPlanBookingComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild(ApDynComponentComponent, {static: true}) public dynComponent: ApDynComponentComponent;
  public data: IPpPlanBookingComponentData;
  public items$ = new BehaviorSubject<IPpEntryPlanBookingGridItem[]>([]);
  public columns$: Observable<ApDynGridColumnConfigBase[]> = of([]);
  public loading$: Observable<boolean> = of(false);
  public pager: ApDynGridPagerWizardConfig;
  public componentCaption: string;

  private _subscriptions: Subscription[] = [];

  constructor(private formStore: FormStore,
              private fieldStore: FieldStore,
              private loginStore: LoginStore,
              private driverStore: DriverStore,
              private mapViewStore: MapViewStore,
              private machineStore: MachineStore,
              private settingsStore: SettingsStore,
              private languageStore: LanguageStore,
              private cropTypeStore: CropTypeStore,
              private instrumentStore: InstrumentStore,
              private modalDialogStore: ModalDialogStore,
              private campaignYearStore: CampaignYearStore,
              private plantProtectionPlanBookStore: PlantProtectionPlanBookStore,
              private dateService: ApDateService,
              private ppCommonService: PpCommonService,
              private nutrientService: ApNutrientService,
              private translationService: ApTranslationService,
              private roundNumericService: GetRoundNumericService,
              private roundNumericPipe: GetRoundNumericPipe) {
  }

  public ngOnInit(): void {
    this.componentCaption = this.data.IsBooked ? 'Global__Reset' : 'Global__Bookings';
    this.loading$ = this._getGridLoading();
    this.columns$ = this._getGridColumns();
    this.pager = this._getGridPager();
    this._setGridItems();
  }

  public ngAfterViewInit(): void {
    this._subscriptions.push(
      this.dynComponent.SelectedItems$.subscribe((items: IPpEntryPlanBookingGridItem[]) => {
        const fieldsToSelect: string[] = items.filter(x => x.FieldId).map(i => i.FieldId.toString());
        this.fieldStore.changeSelectedField(fieldsToSelect);
      })
    );
    this._subscriptions.push(
      this.items$.subscribe((items: IPpEntryPlanBookingGridItem[]): void => {
        const itemsToSelect = items.map(i => i.Id);
        setTimeout(() => this.dynComponent.dynGrid.gridPaging.setSelectedKeys(itemsToSelect));
      })
    );
  }

  public ngOnDestroy(): void {
    this._subscriptions.forEach(s => s.unsubscribe());
  }

  public onEdit(dataItem: IPpEntryPlanBookingGridItem): void {
    const dialog = {
      title: this.translationService.translate('Global__Edit'),
      show: true,
      buttons: [
        {
          key: 'cancel',
          text: 'Global__Cancel',
          primary: false
        },
        {
          key: 'apply',
          text: 'Global__Ok',
          primary: true,
          disable: ModalDialogButtonDisable.FormInvalid,
        }
      ],
      formConfig: {
        fieldSets: this._getModalFieldSets(dataItem),
        validators: undefined,
        asyncValidators: undefined,
        values: ObjectFactory.Copy(dataItem)
      }
    } as IModalDialogData;
    const resultSubscription = this.modalDialogStore.Listen(s => s.result)
      .pipe(skip(1))
      .subscribe((result) => {
        if (result?.key === 'apply') {
          this._updateOverviewItems({ids: [dataItem.Id], value: ObjectFactory.Copy(result.formValues)});
          resultSubscription.unsubscribe();
        } else if (result?.key === 'cancel') {
          resultSubscription.unsubscribe();
        }
      });
    this.modalDialogStore.setModalDialogData(dialog);
  }

  private _getGridLoading(): Observable<boolean> {
    return combineLatest([
      this.fieldStore.Listen(x => x.loading),
      this.settingsStore.Listen(x => x.loading),
      this.languageStore.Listen(x => x.loading),
      this.driverStore.Listen(x => x.loading),
      this.instrumentStore.Listen(x => x.loading),
      this.machineStore.Listen(x => x.loading)
    ]).pipe(
      map((loadings) => loadings.some((x) => x))
    );
  }

  private _getGridColumns(): Observable<ApDynGridColumnConfigBase[]> {
    return combineLatest([
      this.languageStore.SelectedLanguage$,
      this.settingsStore.FirstSetting$
    ]).pipe(
      filter(([language, settings]) => !!language && !!settings),
      map(([language, settings]) => [
        new ApDynGridStatusColumnConfig({
          field: nameOf<IPpEntryPlanBookingGridItem>('Status'),
          class: nameOf<IPpEntryPlanBookingGridItem>('StatusClass'),
          description: nameOf<IPpEntryPlanBookingGridItem>('StatusDesc'),
          title: '',
          filterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: `${nameOf<IPpEntryPlanBookingGridItem>('FieldNumber')}`,
          hide: true,
          width: 40,
          cssClass: 'right',
          filterType: FilterType.NUMBER,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini_Subnumber',
          field: `${nameOf<IPpEntryPlanBookingGridItem>('FieldSubnumber')}`,
          width: 40,
          hide: true,
          filterType: FilterType.NUMBER,
          cssClass: 'right',
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Number',
          field: `${nameOf<IPpEntryPlanBookingGridItem>('FieldNumberWithSubnumber')}`,
          hide: new ApDynGridColumnHideConfig({
            mapHide: false,
            selfHide: this.mapViewStore.Listen(s => s.mode).pipe(map((m) => m !== MapViewMode.NORMAL)),
          }),
          width: 50,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Name',
          field: `${nameOf<IPpEntryPlanBookingGridItem>('FieldName')}`,
          width: 110,
          cssClass: 'left',
          sortIndex: 0,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Docu_Ini__Area',
          field: `${nameOf<IPpEntryPlanBookingGridItem>('Area')}`,
          width: 50,
          headerFilterable: true,
          tooltip: (dataItem: IPpEntryPlanBookingGridItem) => this.roundNumericService.stringify(dataItem?.Area, 4),
          cssClass: 'right',
          filterType: FilterType.NUMBER,
          pipes: [{
            pipe: this.roundNumericPipe,
            args: [settings.DigitsAfterDecimalPoint]
          }]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__Crop',
          field: `${nameOf<IPpEntryPlanBookingGridItem>('Crop')}`,
          width: 80,
          hide: true,
          headerFilterable: true
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global__EC',
          field: `${nameOf<IPpEntryPlanBookingGridItem>('EcValue')}`,
          width: 50,
          hide: true,
          cssClass: 'right',
          filterType: FilterType.NUMBER
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Global__Product',
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Avg_Symbol',
              field: `${nameOf<IPpEntryPlanBookingGridItem>('ProductAverages')}`,
              tooltip: (dataItem: IPpEntryPlanBookingGridItem) => dataItem?.ProductAveragesTooltip,
              width: 150,
              multiline: true,
              filterable: true
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Sum',
              field: `${nameOf<IPpEntryPlanBookingGridItem>('ProductSum')}`,
              tooltip: (dataItem: IPpEntryPlanBookingGridItem) => dataItem?.ProductSumTooltip,
              width: 80,
              multiline: true,
              filterable: true
            })
          ]
        }),
        new ApDynGridGroupColumnConfig({
          title: 'Global__Water',
          hide: true,
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Avg_Symbol',
              field: `${nameOf<IPpEntryPlanBookingGridItem>('WaterRate')}`,
              hide: true,
              width: 60,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              template: PropertyTemplate.NUMBER,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, {ToReplace: [PpNoDataValue, undefined], ReplaceWith: ''}]
              }]
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Global__Sum',
              field: `${nameOf<IPpEntryPlanBookingGridItem>('WaterSum')}`,
              tooltip: (dataItem: IPpEntryPlanBookingGridItem) => dataItem?.WaterSumTooltip,
              hide: true,
              cssClass: 'right',
              filterType: FilterType.NUMBER,
              template: PropertyTemplate.NUMBER,
              width: 60,
              pipes: [{
                pipe: this.roundNumericPipe,
                args: [0, {ToReplace: [PpNoDataValue, undefined], ReplaceWith: ''}]
              }]
            })
          ]
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Global_Application_Date',
          field: `${nameOf<IPpEntryPlanBookingGridItem>('ApplicationDate')}`,
          hide: true,
          width: 80,
          filterable: true,
          format: language.DateFormat,
        }),
        new ApDynGridPropertyColumnConfig({
          title: 'Duration',
          field: `${nameOf<IPpEntryPlanBookingGridItem>('Duration')}`,
          format: 'HH:mm',
          hide: true,
          width: 80,
          filterable: true
        }),
        new ApDynGridGroupColumnConfig({
          title: 'agrioptions_resources',
          hide: true,
          groupColumns: [
            new ApDynGridPropertyColumnConfig({
              title: 'Base__Engine',
              field: 'Machine.NameWithSign',
              hide: true,
              width: 100
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'AgriConnect_Ini__Tool',
              field: 'Instrument.Name',
              hide: true,
              width: 100
            }),
            new ApDynGridPropertyColumnConfig({
              title: 'Docu_Ini__Motorist',
              field: 'Driver.ShortFullName',
              hide: true,
              width: 100
            })
          ]
        }),
        new ApDynGridEditColumnConfig({})
      ])
    );
  }

  private _getGridPager(): ApDynGridPagerWizardConfig {
    const buttonTitle = this.data.IsBooked ? 'Global__Reset' : 'Admin_Pages_Popups__Book';
    return new ApDynGridPagerWizardConfig(
      new ApDynGridPagerWizardButton('Global__Cancel', ApUtilService.createEventEmitter(this._onClose.bind(this), this._subscriptions)),
      new ApDynGridPagerWizardSection(),
      new ApDynGridPagerWizardButton(buttonTitle, ApUtilService.createEventEmitter(this._booking.bind(this), this._subscriptions),
        {active: this.dynComponent.SelectedItems$.pipe(map((items) => items.length !== 0))}),
      {
        formConfig: {
          showMassEdit: false,
          onSubmit: ApUtilService.createEventEmitter(this._updateOverviewItems.bind(this), this._subscriptions),
          config: this._getPagerFieldSets()
        }
      }
    );
  }

  private _setGridItems(): void {
    let items = this.data.DataItem?.filter(x => !x.DeletedAt);
    if (this.data.IsBooked) {
      items = items.filter(x => x.BookedBy);
    } else {
      items = items.filter(x => !x.BookedBy);
    }
    const gridItems: IPpEntryPlanBookingGridItem[] = items.map(planBook => {
      const field = this.fieldStore.getFieldById(planBook.FieldId);
      const geom = this.fieldStore.getFieldGeomById(planBook.FieldGeomId);
      const driver = this.driverStore.getDriverById(planBook.ExportDriver);
      const machine = this.machineStore.getMachineById(planBook.ExportMachine);
      const instrument = this.instrumentStore.getInstrumentById(planBook.ExportInstrument);
      const isWorkTypeSpraying = this.ppCommonService.isWorkTypeSpraying(planBook);
      const waterSum = isWorkTypeSpraying ? this.ppCommonService.getWaterAmountBasedOnOperationMode(planBook) : PpNoDataValue;
      const waterUnit = isWorkTypeSpraying ? this.translationService.translate('Api_Enums__Litre') : undefined;
      const area = geom?.AreaHa ?? 0;
      const item: IPpEntryPlanBookingGridItem = {
        Id: planBook.Id,
        Status: this.nutrientService.getFertilizerStatus(planBook.ApplicationMode, this.data?.IsBooked)?.state,
        StatusClass: this.nutrientService.getFertilizerStatus(planBook.ApplicationMode, this.data?.IsBooked)?.class,
        StatusDesc: this.nutrientService.getFertilizerStatusDescription(planBook.ApplicationMode, this.data?.IsBooked),
        FieldId: field?.Id,
        FieldName: field?.FieldName,
        FieldNumber: field?.FieldNumber,
        FieldSubnumber: field?.FieldSubnumber,
        FieldNumberWithSubnumber: this.fieldStore.getFieldNumberAndSubNumber(field),
        Area: area,
        EcValue: planBook.EcValue,
        Crop: this.cropTypeStore.getDefaultCroptype(planBook.MainCropId)?.Description ?? '',
        ProductAverages: this.ppCommonService.getAppliedProductsExpr(planBook.ProductList),
        ProductAveragesTooltip: this.ppCommonService.getAppliedProductsExpr(planBook.ProductList, true),
        ProductSum: isWorkTypeSpraying ? this.ppCommonService.getAppliedProductSumExpr(planBook.ProductList, {
          areaHa: area,
          withoutProdName: true
        }) : undefined,
        ProductSumTooltip: isWorkTypeSpraying ? this.ppCommonService.getAppliedProductSumExpr(planBook.ProductList, {
          areaHa: area,
          isTooltip: true
        }) : undefined,
        WaterRate: isWorkTypeSpraying ? this.ppCommonService.getApplicationValue(planBook) : PpNoDataValue,
        WaterSum: isWorkTypeSpraying ? this.ppCommonService.getWaterAmountBasedOnOperationMode(planBook) : PpNoDataValue,
        WaterSumTooltip: isWorkTypeSpraying && waterSum >= 0 ? `${waterSum ?? 0} ${waterUnit}` : '',
        ApplicationDate: this.dateService.toFarmDate(planBook.ApplicationDate).toDate(),
        Duration: this.dateService.getDateWithTimeFromMilliseconds(planBook.TEnd?.TotalMilliseconds ?? 0),
        Driver: driver,
        Machine: machine,
        Instrument: instrument,
        SourceItem: planBook
      };
      return item;
    });
    setTimeout(() => this.items$.next(gridItems), 10);
  }

  private _getPagerFieldSets(): ApDynformsConfigFieldset[] {
    const campaignYearStart = new Date(this.campaignYearStore.getSelectedCampaignYear().DefaultStart);
    const campaignYearEnd = new Date(this.campaignYearStore.getSelectedCampaignYear().DefaultEnd);
    return [
      new ApDynformsConfigFieldset({
        legend: 'Docu_Ini__Time',
        key: 'Time',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigDatepicker({
            key: 'ApplicationDate',
            label: 'Global_Application_Date',
            minDate: campaignYearStart,
            maxDate: campaignYearEnd,
          }),
          new ApDynformsConfigTimepicker({
            key: 'Duration',
            label: 'Docu_Ini__Duration',
            format: 'HH:mm',
            minSteps: 5,
            secSteps: 60
          })
        ],
      }),
      new ApDynformsConfigFieldset({
        legend: 'agrioptions_resources',
        key: 'Resources',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigComboBox({
            key: 'Machine',
            label: 'Base__Engine',
            options: this.machineStore.Listen(_ => _.data),
            textField: 'NameWithSign',
            valueField: 'Id',
            valuePrimitive: false,
            value: null,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'Instrument',
            label: 'Docu_Ini__Tool',
            options: this.instrumentStore.Listen(s => s.data),
            textField: 'Name',
            valueField: 'Id',
            valuePrimitive: false,
            value: null,
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'Driver',
            label: 'Docu_Ini__Motorist',
            options: this.driverStore.Listen(_ => _.data),
            textField: 'ShortFullName',
            valueField: 'Id',
            valuePrimitive: false,
            value: null,
            sort: 1
          }),
          new ApDynformsConfigPlaceholder()
        ],
      })
    ];
  }

  private _getModalFieldSets(dataItem: IPpEntryPlanBookingGridItem): ApDynformsConfigFieldset[] {
    const campaignYearStart = new Date(this.campaignYearStore.getSelectedCampaignYear().DefaultStart);
    const campaignYearEnd = new Date(this.campaignYearStore.getSelectedCampaignYear().DefaultEnd);
    return [
      new ApDynformsConfigFieldset({
        legend: 'Docu_Ini__Time',
        key: 'EditTime',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigDatepicker({
            key: 'ApplicationDate',
            label: 'Global_Application_Date',
            value: dataItem.ApplicationDate,
            minDate: campaignYearStart,
            maxDate: campaignYearEnd
          }),
          new ApDynformsConfigTimepicker({
            key: 'Duration',
            label: 'Docu_Ini__Duration',
            format: 'HH:mm',
            value: dataItem.Duration,
            minSteps: 5,
            secSteps: 60
          })
        ],
      }),
      new ApDynformsConfigFieldset({
        legend: 'agrioptions_resources',
        key: 'EditResources',
        useMaxWidth: true,
        config: [
          new ApDynformsConfigComboBox({
            key: 'Machine',
            label: 'Base__Engine',
            textField: 'NameWithSign',
            valueField: 'Id',
            valuePrimitive: false,
            value: dataItem.Machine,
            options: this.machineStore.Listen(_ => _.data),
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'Instrument',
            label: 'Docu_Ini__Tool',
            textField: 'Name',
            valueField: 'Id',
            valuePrimitive: false,
            value: dataItem.Instrument,
            value$: this.modalDialogStore.listenChanges().pipe(
              filter(values => values['Machine'] || values['Instrument']),
              map(values => {
                if (values['Instrument']) {
                  return values['Instrument'];
                }
                const formValues = this.modalDialogStore.getFormValues();
                if (formValues['Instrument']) {
                  return formValues['Instrument'];
                }
                if (values['Machine'].DefaultInstrument) {
                  return values['Machine'].DefaultInstrument;
                }
                return null;
              })
            ),
            options: this.instrumentStore.Listen(s => s.data),
            sort: 1
          }),
          new ApDynformsConfigComboBox({
            key: 'Driver',
            label: 'Docu_Ini__Motorist',
            textField: 'ShortFullName',
            valueField: 'Id',
            valuePrimitive: false,
            value: dataItem.Driver,
            value$: this.modalDialogStore.listenChanges().pipe(
              filter(values => values['Machine'] || values['Driver']),
              map(values => {
                if (values['Driver']) {
                  return values['Driver'];
                }
                const formValues = this.modalDialogStore.getFormValues();
                if (formValues['Driver']) {
                  return formValues['Driver'];
                }
                if (values['Machine'].DefaultDriver) {
                  return values['Machine'].DefaultDriver;
                }
                return null;
              })
            ),
            options: this.driverStore.Listen(_ => _.data),
            sort: 1
          }),
          new ApDynformsConfigPlaceholder()
        ],
      })
    ];
  }

  private _updateOverviewItems(submitData: { ids: any[], value: any }): void {
    this.items$.next(this.items$.getValue().map((planBook: IPpEntryPlanBookingGridItem) => {
      if (submitData.ids.includes(planBook.Id)) {
        if (!!submitData.value.ApplicationDate) {
          planBook.ApplicationDate = new Date(submitData.value.ApplicationDate);
        }
        if (!!submitData.value.Duration) {
          planBook.Duration = submitData.value.Duration;
        }
        if (!!submitData.value.Driver) {
          planBook.Driver = submitData.value.Driver;
        }
        if (!!submitData.value.Instrument) {
          planBook.Instrument = submitData.value.Instrument;
        }
        if (!!submitData.value.Machine) {
          planBook.Machine = submitData.value.Machine;
        }
      }
      return planBook;
    }));
  }

  private _booking(): void {
    const selectedItems = this.dynComponent.getSelectedItems() as IPpEntryPlanBookingGridItem[];
    const updatedPlanBooks = this._updateData(selectedItems);
    if (updatedPlanBooks && updatedPlanBooks.length > 0) {
      const dataToSend = updatedPlanBooks.map(planBook => ({planBook, logFile: undefined}));
      if (this.data.IsBooked) {
        this.plantProtectionPlanBookStore.unBookPlanBooks(dataToSend);
      } else {
        this.plantProtectionPlanBookStore.bookPlanBooks(dataToSend);
      }
    }
    this._onClose();
  }

  private _updateData(itemsToUpdate: IPpEntryPlanBookingGridItem[]): IPlantProtectionPlanBook[] {
    if (!itemsToUpdate || itemsToUpdate.length <= 0) {
      return [];
    }
    return itemsToUpdate.map(row => {
      const selectedItem = ObjectFactory.Copy(row as IPpEntryPlanBookingGridItem);
      const copiedSourceItem = ObjectFactory.Copy(selectedItem.SourceItem);
      if (!copiedSourceItem) {
        return null;
      }
      copiedSourceItem.BookedAt = !this.data.IsBooked ? this.dateService.getUtc() : null;
      copiedSourceItem.BookedBy = !this.data.IsBooked ? this.loginStore.UserId : null;
      copiedSourceItem.TStart = ApTimeSpanUtil.getEmptyTimeSpan();
      copiedSourceItem.TEnd = ApTimeSpanUtil.getTimeSpanFromDate(selectedItem.Duration, true);
      copiedSourceItem.ApplicationDate = this.dateService.getDateNoon(selectedItem.ApplicationDate);
      copiedSourceItem.ExportDriver = selectedItem.Driver?.Id;
      copiedSourceItem.ExportMachine = selectedItem.Machine?.Id;
      copiedSourceItem.ExportInstrument = selectedItem.Instrument?.Id;
      return copiedSourceItem;
    }).filter(x => !!x);
  }

  private _onClose(): void {
    this.formStore.closeForm();
  }
}
